export const TimeToStartTrip = (tripDateTime, currentDateTime) => {
  let trip_date_time_stamp = Date.parse(tripDateTime);
  let currentDateTimeStamp = Date.parse(currentDateTime);
  return (trip_date_time_stamp - currentDateTimeStamp) / 60000;
};
